import React, { useCallback, useMemo, useState } from 'react'
import OfferListCarousel from 'components/OfferList/OfferListCarousel'
import OfferCarouselLookingForSomethingElse from 'home/components/LookingForSomethingElse/OfferCarouselLookingForSomethingElse'
import { LOOKING_FOR_SOMETHING_ELSE_CONTENT } from 'home/components/LookingForSomethingElse/constants'
import useOfferList from 'hooks/Offers/useOfferList'
import styled from 'styled-components'
import { rem } from 'polished'
import LayoutContainer from 'components/Common/LayoutContainer'
import Group from 'components/utils/Group'
import OfferCarouselHeader from 'home/components/OfferCarousels/common/OfferCarouselHeader'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import OfferCardCarouselSectionFilters from 'components/Common/OfferCardCarousel/OfferCardCarouselSectionFilters'
import { take } from 'lib/array/arrayUtils'
import useOfferListFilters from 'hooks/Offers/useOfferListFilters'
import { getHolidayTypeIcon } from 'lib/search/searchUtils'

const Container = styled(Group)`
  padding-top: ${rem(40)};
  padding-bottom: ${rem(40)};
`

interface Props extends App.ContentfulWebPageOfferCarousel {
  filterOptions?: { [listKey: string]: App.OfferListFilterOptions | undefined }
}

function ContentfulOfferCarousel(props: Props) {
  const { title, viewAllLink, filters } = props
  const [selectedFilter, setSelectedFilter] = useState<string>()
  const offerList = useOfferList({
    ...filters,
    holidayTypes: selectedFilter ? [selectedFilter] : [],
    sortBy: 'home',
    useUnifiedSearchEndpoint: true,
  })
  const listFilters = useOfferListFilters({ ...filters, useUnifiedSearchEndpoint: true })

  const toggleFilter = useCallback((name: string) => {
    setSelectedFilter(selectedFilter === name ? '' : name)
  }, [selectedFilter])

  const filtersOptions = useMemo((): Array<{ label: string, value: string | number, icon?: React.ReactElement }> => {
    const holidayFilters = listFilters.orderedFilters?.holidayTypes ? take(listFilters.orderedFilters?.holidayTypes, 5) : []

    return holidayFilters.map((filter) => ({
      label: filter.value,
      value: filter.value,
      icon: getHolidayTypeIcon(filter.value.toLowerCase()),
    }))
  }, [listFilters.orderedFilters?.holidayTypes])

  let lfseOption = LOOKING_FOR_SOMETHING_ELSE_CONTENT.hotels.to
  if (props.lookingForSomethingElseOption && props.lookingForSomethingElseOption in LOOKING_FOR_SOMETHING_ELSE_CONTENT) {
    lfseOption = LOOKING_FOR_SOMETHING_ELSE_CONTENT[props.lookingForSomethingElseOption].to
  }

  return <Container direction="vertical" gap={16}>
    <LayoutContainer>
      <VerticalSpacer gap={20}>
        <OfferCarouselHeader allTo={viewAllLink}>
          <span dangerouslySetInnerHTML={{ __html: title }} />
        </OfferCarouselHeader>
        {filtersOptions.length > 0 && <OfferCardCarouselSectionFilters
          options={filtersOptions}
          value={selectedFilter}
          onChange={toggleFilter}
        />}
      </VerticalSpacer>
    </LayoutContainer>
    <OfferListCarousel overrideOfferList={offerList}>
      <OfferCarouselLookingForSomethingElse to={lfseOption} />
    </OfferListCarousel>
  </Container>
}

export default ContentfulOfferCarousel
